import React, { useEffect, useState, useCallback } from "react";

import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import { isAfter, parse, isValid, format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  Flex,
  Button,
  Text,
  SimpleGrid,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";

import CustomSelect from "../../../../components/CustomSelect";

import {
  telefone as telMask,
  onlyNumbers as numbersMask,
} from "../../../../utils/masks";
import EquipeSAService from "../../../../../main/services/EquipeSAService";
import DiaHorario from "./DiaHorario";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import DesligarModal from "./Desligar";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import {
  criancaFunc,
  Permission,
  servicos,
} from "../../../../../helpers/Funcionalidades";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { nivelarDias } from "../../../../utils/diaHorarioFilter.js";
import { organizarDias } from "../../../../utils/diaHorarioFilter.js";
import { useHistory, useLocation, useParams } from "react-router";

const VisualizarEditarEquipeModal = ({
  isOpen,
  onOpen,
  onClose,
  id,
  isEdicao,
  setEditarEquipeServ,
  editarEquipeServ,
  opcaoCadastro,
  setLoadingPainel,
}) => {
  const { roleKeycloack, user } = useAuthProvider();
  const { id: idServico } = useParams();
  const { idPJ, servicoData } = useAppContext();

  const {
    isOpen: isOpenDesligar,
    onOpen: onOpenDesligar,
    onClose: onCloseDesligar,
  } = useDisclosure();

  const [isVisualizacao, setIsVisualizacao] = useState(isEdicao ? false : true);
  const [tiposEquipe, setTiposEquipe] = useState({
    options: [],
    isLoading: false,
  });

  const [acessoMca] = useState({
    options: [
      { id: 1, descricao: "Sim" },
      { id: 2, descricao: "Não" },
    ],
    isLoading: false,
  });
  const [funcoesER, setFuncoesER] = useState({ options: [], isLoading: false });
  const [funcoesDPS, setFuncoesDPS] = useState({
    options: [],
    isLoading: false,
  });
  const [cargos, setCargos] = useState({ options: [], isLoading: false });
  const [regimesTrabalho, setRegimesTrabalho] = useState({
    options: [],
    isLoading: false,
  });
  const [regimesPlantao, setRegimesPlantao] = useState({
    options: [],
    isLoading: false,
  });
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({
    tipoEquipeAcolhimento: "",
    possuiAcessoMca: "",
    nome: "",
    funcaoEquipeAcolhimento: "",
    funcaoEquipeAcolhimentoER: "",
    funcaoEquipeAcolhimentoDPS: "",
    cargoEquipeAcolhimento: "",
    telefone: "",
    email: "",
    cargaHorariaSemanal: "",
    inicioAtividade: "",
    regimeTrabalhoAcolhimento: "",
    regimePlantaoAcolhimento: "",
    outroRegimePlantao: "",
    horarioTrabalho: "",
    listaHorarios: "",
    domingo: [{ id: 0, nomeDiaSemana: "domingo", start: "", end: "" }],
    segunda: [{ id: 0, nomeDiaSemana: "segunda", start: "", end: "" }],
    terca: [{ id: 0, nomeDiaSemana: "terca", start: "", end: "" }],
    quarta: [{ id: 0, nomeDiaSemana: "quarta", start: "", end: "" }],
    quinta: [{ id: 0, nomeDiaSemana: "quinta", start: "", end: "" }],
    sexta: [{ id: 0, nomeDiaSemana: "sexta", start: "", end: "" }],
    sabado: [{ id: 0, nomeDiaSemana: "sabado", start: "", end: "" }],
  });

  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const handleGetMembro = useCallback(() => {
    if (id && id > 0) {
      EquipeSAService.getMembroEquipe(id)
        .then((res) => {
          const {
            servicoAcolhimento,
            tipoEquipeAcolhimento,
            funcaoEquipeAcolhimento,
            cargoEquipeAcolhimento,
            telefone,
            email,
            inicioAtividade,
            cargaHoraria,
            cargaHorariaSemanal,
            regimeTrabalhoAcolhimento,
            regimePlantaoAcolhimento,
            outroRegimePlantao,
            listaHorarios,
            possuiAcessoMca,
            ...resto
          } = res.data;

          const tempHorarioTrabalho = listaHorarios
            ? organizarDias(listaHorarios)
            : "";

          const initialValues = {
            ...resto,
            possuiAcessoMca:
              possuiAcessoMca === "S"
                ? { id: 2, descricao: "Sim" }
                : possuiAcessoMca === "N"
                  ? { id: 1, descricao: "Não" }
                  : "",
            tipoEquipeAcolhimento: tipoEquipeAcolhimento
              ? tipoEquipeAcolhimento
              : "",
            cargoEquipeAcolhimento: cargoEquipeAcolhimento
              ? cargoEquipeAcolhimento
              : "",
            funcaoEquipeAcolhimentoDPS:
              tipoEquipeAcolhimento.nomeEquipe ===
              "Demais profissionais do Serviço"
                ? funcaoEquipeAcolhimento
                : "",
            funcaoEquipeAcolhimentoER:
              tipoEquipeAcolhimento.nomeEquipe === "Equipe de Referência" ||
              (tipoEquipeAcolhimento.id === 2 &&
                servicoData.tipoServicoAcolhimento.regime === "SAF")
                ? funcaoEquipeAcolhimento
                : "",
            telefone: telefone ? telefone : "",
            email: email ? email : "",
            inicioAtividade: inicioAtividade
              ? format(new Date(inicioAtividade), "dd/MM/yyyy")
              : "",
            cargaHorariaSemanal: cargaHorariaSemanal ? cargaHorariaSemanal : "",
            regimeTrabalhoAcolhimento: regimeTrabalhoAcolhimento
              ? regimeTrabalhoAcolhimento
              : "",
            regimePlantaoAcolhimento: regimePlantaoAcolhimento
              ? regimePlantaoAcolhimento
              : "",
            outroRegimePlantao: outroRegimePlantao ? outroRegimePlantao : "",
            listaHorarios: "",
            domingo:
              tempHorarioTrabalho?.domingo.length > 0
                ? tempHorarioTrabalho.domingo
                : [{ id: 0, nomeDiaSemana: "domingo", start: "", end: "" }],
            segunda:
              tempHorarioTrabalho?.segunda.length > 0
                ? tempHorarioTrabalho.segunda
                : [{ id: 0, nomeDiaSemana: "segunda", start: "", end: "" }],
            terca:
              tempHorarioTrabalho?.terca.length > 0
                ? tempHorarioTrabalho.terca
                : [{ id: 0, nomeDiaSemana: "terca", start: "", end: "" }],
            quarta:
              tempHorarioTrabalho?.quarta.length > 0
                ? tempHorarioTrabalho.quarta
                : [{ id: 0, nomeDiaSemana: "quarta", start: "", end: "" }],
            quinta:
              tempHorarioTrabalho?.quinta.length > 0
                ? tempHorarioTrabalho.quinta
                : [{ id: 0, nomeDiaSemana: "quinta", start: "", end: "" }],
            sexta:
              tempHorarioTrabalho?.sexta.length > 0
                ? tempHorarioTrabalho.sexta
                : [{ id: 0, nomeDiaSemana: "sexta", start: "", end: "" }],
            sabado:
              tempHorarioTrabalho?.sabado.length > 0
                ? tempHorarioTrabalho.sabado
                : [{ id: 0, nomeDiaSemana: "sabado", start: "", end: "" }],
          };

          setInitialValues(initialValues);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            title: "Atenção!",
            text: "Registro não encontrado",
            icon: "warning",
            confirmButtonText: "Fechar",
            confirmButtonColor: "#169499",
          }).then(() => {
            onClose();
          });
        });
    }
  }, [
    id,
    setInitialValues,
    setLoading,
    onClose,
    servicoData.tipoServicoAcolhimento.regime,
  ]);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    handleGetMembro();
  }, [handleGetMembro]);

  useEffect(() => {
    if (isVisualizacao) {
      handleGetMembro();
    }
  }, [isVisualizacao, handleGetMembro]);

  const handleMembroDesligado = () => {
    onCloseDesligar();
    onClose();
  };

  const backAlert = () => {
    if (isVisualizacao) {
      onClose();
    } else {
      if (editarEquipeServ) {
        Swal.fire({
          title: "Tem certeza que deseja cancelar?",
          text: "As informações serão perdidas.",
          icon: "error",
          showCancelButton: true,
          confirmButtonColor: "#169499",
          cancelButtonColor: "#169499",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then((result) => {
          if (result.isConfirmed) {
            onClose();
            setEditarEquipeServ(false);
          }
        });
      } else {
        onClose();
      }
    }
  };

  const handleGetTiposEquipe = () => {
    setTiposEquipe({ ...tiposEquipe, isLoading: true });

    EquipeSAService.listarTiposEquipeSA().then((res) => {
      let tiposFiltrados;

      if (opcaoCadastro) {
        tiposFiltrados = res.data.filter((tipo) => tipo.id === opcaoCadastro);
      } else {
        tiposFiltrados = res.data;
      }

      setTiposEquipe({ options: tiposFiltrados, isLoading: false });
    });
  };

  const handleGetFuncoesER = (id) => {
    setFuncoesER({ ...funcoesER, isLoading: true });
    EquipeSAService.listarFuncoesEquipeSA(id).then((res) => {
      setFuncoesER({ options: res.data, isLoading: false });
    });
  };

  const handleGetFuncoesDPS = (id) => {
    setFuncoesDPS({ ...funcoesDPS, isLoading: true });
    EquipeSAService.listarFuncoesEquipeSA(id).then((res) => {
      setFuncoesDPS({ options: res.data, isLoading: false });
    });
  };

  const handleGetCargos = () => {
    setCargos({ ...cargos, isLoading: true });
    EquipeSAService.listarCargosEquipeSA(idServico).then((res) => {
      setCargos({ options: res.data, isLoading: false });
    });
  };

  const handleGetRegimesTrabalho = () => {
    setRegimesTrabalho({ ...regimesTrabalho, isLoading: true });
    EquipeSAService.listarRegimeTrabalhoEquipeSA().then((res) => {
      setRegimesTrabalho({ options: res.data, isLoading: false });
    });
  };

  const handleGetRegimesPlantao = () => {
    setRegimesPlantao({ ...regimesPlantao, isLoading: true });
    EquipeSAService.listarRegimePlantaoEquipeSA().then((res) => {
      setRegimesPlantao({ options: res.data, isLoading: false });
    });
  };

  const schema = Yup.object().shape({
    tipoEquipeAcolhimento: Yup.mixed("Este campo é obrigatório!").required(
      "Este campo é obrigatório!",
    ),
    nome: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    funcaoEquipeAcolhimentoER: Yup.mixed("Este campo é obrigatório!").when(
      "tipoEquipeAcolhimento",
      {
        is: (tipo) =>
          tipo
            ? tipo.nomeEquipe === "Equipe de Referência" ||
              (tipo.id === 2 &&
                servicoData.tipoServicoAcolhimento.regime === "SAF")
            : false,
        then: Yup.mixed("Este campo é obrigatório!").required(
          "Este campo é obrigatório!",
        ),
      },
    ),
    funcaoEquipeAcolhimentoDPS: Yup.mixed("Este campo é obrigatório!").when(
      ["tipoEquipeAcolhimento", "cargoEquipeAcolhimento"],
      {
        is: (tipo, cargo) =>
          tipo
            ? tipo.nomeEquipe === "Demais profissionais do Serviço" &&
              (cargo ? cargo.nomeCargo === "Outros" : false)
            : false,
        then: Yup.mixed("Este campo é obrigatório!").required(
          "Este campo é obrigatório!",
        ),
      },
    ),
    cargoEquipeAcolhimento: Yup.mixed().when("tipoEquipeAcolhimento", {
      is: (tipo) =>
        tipo
          ? tipo.nomeEquipe === "Demais profissionais do Serviço" &&
            servicoData.tipoServicoAcolhimento.regime !== "SAF"
          : false,
      then: Yup.mixed("Este campo é obrigatório!").required(
        "Este campo é obrigatório!",
      ),
    }),
    telefone: Yup.mixed().when("tipoEquipeAcolhimento", {
      is: (tipo) => (tipo ? tipo.nomeEquipe === "Equipe de Referência" : false),
      then: Yup.string("Telefone inválido!")
        .min(14, "Telefone inválido!")
        .max(15, "Telefone inválido!")
        .nullable()
        .trim("Este campo é obrigatório!"),
    }),
    email: Yup.mixed().when("tipoEquipeAcolhimento", {
      is: (tipo) => (tipo ? tipo.nomeEquipe === "Equipe de Referência" : false),
      then: Yup.string("Email inválido!").email("Email inválido!").nullable(),
    }),
    cargaHorariaSemanal: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    inicioAtividade: Yup.string("Este campo é obrigatório!")
      .nullable()
      .required("Este campo é obrigatório!")
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .test(
        "inicioAtividadeAfterToday",
        "A data informada não pode ser uma data futura!",
        (value) => {
          if (!Boolean(value)) {
            return false;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        },
      ),
    regimeTrabalhoAcolhimento: Yup.mixed().when("tipoEquipeAcolhimento", {
      is: (tipo) =>
        tipo ? tipo.nomeEquipe === "Demais profissionais do Serviço" : false,
      then: Yup.mixed("Este campo é obrigatório!").required(
        "Este campo é obrigatório!",
      ),
    }),
    regimePlantaoAcolhimento: Yup.mixed().when(
      ["regimeTrabalhoAcolhimento", "tipoEquipeAcolhimento"],
      {
        is: (regime, tipo) =>
          regime
            ? regime.nomeRegime === "Plantonista" &&
              tipo.nomeEquipe === "Demais profissionais do Serviço"
            : false,
        then: Yup.mixed("Este campo é obrigatório!").required(
          "Este campo é obrigatório!",
        ),
      },
    ),
    outroRegimePlantao: Yup.string().when(
      ["regimePlantaoAcolhimento", "tipoEquipeAcolhimento"],
      {
        is: (regime, tipo) =>
          regime
            ? regime.nomeRegime === "Outros" &&
              tipo.nomeEquipe === "Demais profissionais do Serviço"
            : false,
        then: Yup.string("Este campo é obrigatório!")
          .required("Este campo é obrigatório!")
          .trim("Este campo é obrigatório!"),
      },
    ),
    listaHorarios: Yup.mixed().when(
      ["tipoEquipeAcolhimento", "regimeTrabalhoAcolhimento"],
      {
        is: (tipo, regime) => {
          return (
            (tipo ? tipo.nomeEquipe === "Equipe de Referência" : false) ||
            (regime ? regime.nomeRegime === "Diarista" : false)
          );
        },
        then: Yup.mixed("Preenchimento obrigatório!").when(
          [
            "domingo",
            "segunda",
            "terca",
            "quarta",
            "quinta",
            "sexta",
            "sabado",
          ],
          (domingo, segunda, terca, quarta, quinta, sexta, sabado, schema) => {
            return schema.test(
              "hasValid",
              "Preenchimento obrigatório!",
              (value, context) => {
                let hasValid = false;
                Object.entries({
                  domingo,
                  segunda,
                  terca,
                  quarta,
                  quinta,
                  sexta,
                  sabado,
                }).forEach((val) => {
                  if (val[1]) {
                    val[1].forEach((horario) => {
                      if (!!horario.start && !!horario.end) {
                        hasValid = true;
                      }
                    });
                  }
                });
                return hasValid;
              },
            );
          },
        ),
      },
    ),
    domingo: Yup.mixed().when(
      ["tipoEquipeAcolhimento", "regimeTrabalhoAcolhimento"],
      {
        is: (tipo, regime) => {
          return (
            (tipo ? tipo.nomeEquipe === "Equipe de Referência" : false) ||
            (regime ? regime.nomeRegime === "Diarista" : false)
          );
        },
        then: Yup.array().of(
          Yup.object().shape(
            {
              start: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 0", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 0) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("end", {
                  is: (end) => !!end,
                  then: Yup.string().required("Campo vazio!"),
                }),
              end: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 1", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 60) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("start", {
                  is: (start) => !!start,
                  then: Yup.string().required("Campo vazio!"),
                })
                .when("start", (start, schema) => {
                  return schema.test(
                    "startEqual",
                    "Horários iguais!",
                    (value) => {
                      if (!!start && !!value) {
                        return start !== value;
                      } else {
                        return true;
                      }
                    },
                  );
                }),
            },
            [["start", "end"]],
          ),
        ),
      },
    ),
    segunda: Yup.mixed().when(
      ["tipoEquipeAcolhimento", "regimeTrabalhoAcolhimento"],
      {
        is: (tipo, regime) => {
          return (
            (tipo ? tipo.nomeEquipe === "Equipe de Referência" : false) ||
            (regime ? regime.nomeRegime === "Diarista" : false)
          );
        },
        then: Yup.array().of(
          Yup.object().shape(
            {
              start: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 0", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 0) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("end", {
                  is: (end) => !!end,
                  then: Yup.string().required("Campo vazio!"),
                }),
              end: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 1", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 60) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("start", {
                  is: (start) => !!start,
                  then: Yup.string().required("Campo vazio!"),
                })
                .when("start", (start, schema) => {
                  return schema.test(
                    "startEqual",
                    "Horários iguais!",
                    (value) => {
                      if (!!start && !!value) {
                        return start !== value;
                      } else {
                        return true;
                      }
                    },
                  );
                }),
            },
            [["start", "end"]],
          ),
        ),
      },
    ),
    terca: Yup.array().of(
      Yup.object().shape(
        {
          start: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 0", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 0) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("end", {
              is: (end) => !!end,
              then: Yup.string().required("Campo vazio!"),
            }),
          end: Yup.string()
            .min(5, "Inválido")
            .test("minimo", "Min. 1", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos < 60) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .test("maximo", "Máx. 23:59", (value, context) => {
              if (value) {
                const horario = value.split(":");
                const minutos = Number(horario[0]) * 60 + Number(horario[1]);
                if (minutos > 1439) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .when("start", {
              is: (start) => !!start,
              then: Yup.string().required("Campo vazio!"),
            })
            .when("start", (start, schema) => {
              return schema.test("startEqual", "Horários iguais!", (value) => {
                if (!!start && !!value) {
                  return start !== value;
                } else {
                  return true;
                }
              });
            }),
        },
        [["start", "end"]],
      ),
    ),
    quarta: Yup.mixed().when(
      ["tipoEquipeAcolhimento", "regimeTrabalhoAcolhimento"],
      {
        is: (tipo, regime) => {
          return (
            (tipo ? tipo.nomeEquipe === "Equipe de Referência" : false) ||
            (regime ? regime.nomeRegime === "Diarista" : false)
          );
        },
        then: Yup.array().of(
          Yup.object().shape(
            {
              start: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 0", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 0) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("end", {
                  is: (end) => !!end,
                  then: Yup.string().required("Campo vazio!"),
                }),
              end: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 1", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 60) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("start", {
                  is: (start) => !!start,
                  then: Yup.string().required("Campo vazio!"),
                })
                .when("start", (start, schema) => {
                  return schema.test(
                    "startEqual",
                    "Horários iguais!",
                    (value) => {
                      if (!!start && !!value) {
                        return start !== value;
                      } else {
                        return true;
                      }
                    },
                  );
                }),
            },
            [["start", "end"]],
          ),
        ),
      },
    ),
    quinta: Yup.mixed().when(
      ["tipoEquipeAcolhimento", "regimeTrabalhoAcolhimento"],
      {
        is: (tipo, regime) => {
          return (
            (tipo ? tipo.nomeEquipe === "Equipe de Referência" : false) ||
            (regime ? regime.nomeRegime === "Diarista" : false)
          );
        },
        then: Yup.array().of(
          Yup.object().shape(
            {
              start: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 0", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 0) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("end", {
                  is: (end) => !!end,
                  then: Yup.string().required("Campo vazio!"),
                }),
              end: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 1", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 60) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("start", {
                  is: (start) => !!start,
                  then: Yup.string().required("Campo vazio!"),
                })
                .when("start", (start, schema) => {
                  return schema.test(
                    "startEqual",
                    "Horários iguais!",
                    (value) => {
                      if (!!start && !!value) {
                        return start !== value;
                      } else {
                        return true;
                      }
                    },
                  );
                }),
            },
            [["start", "end"]],
          ),
        ),
      },
    ),
    sexta: Yup.mixed().when(
      ["tipoEquipeAcolhimento", "regimeTrabalhoAcolhimento"],
      {
        is: (tipo, regime) => {
          return (
            (tipo ? tipo.nomeEquipe === "Equipe de Referência" : false) ||
            (regime ? regime.nomeRegime === "Diarista" : false)
          );
        },
        then: Yup.array().of(
          Yup.object().shape(
            {
              start: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 0", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 0) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("end", {
                  is: (end) => !!end,
                  then: Yup.string().required("Campo vazio!"),
                }),
              end: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 1", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 60) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("start", {
                  is: (start) => !!start,
                  then: Yup.string().required("Campo vazio!"),
                })
                .when("start", (start, schema) => {
                  return schema.test(
                    "startEqual",
                    "Horários iguais!",
                    (value) => {
                      if (!!start && !!value) {
                        return start !== value;
                      } else {
                        return true;
                      }
                    },
                  );
                }),
            },
            [["start", "end"]],
          ),
        ),
      },
    ),
    sabado: Yup.mixed().when(
      ["tipoEquipeAcolhimento", "regimeTrabalhoAcolhimento"],
      {
        is: (tipo, regime) => {
          return (
            (tipo ? tipo.nomeEquipe === "Equipe de Referência" : false) ||
            (regime ? regime.nomeRegime === "Diarista" : false)
          );
        },
        then: Yup.array().of(
          Yup.object().shape(
            {
              start: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 0", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 0) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("end", {
                  is: (end) => !!end,
                  then: Yup.string().required("Campo vazio!"),
                }),
              end: Yup.string()
                .min(5, "Inválido")
                .test("minimo", "Min. 1", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos < 60) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .test("maximo", "Máx. 23:59", (value, context) => {
                  if (value) {
                    const horario = value.split(":");
                    const minutos =
                      Number(horario[0]) * 60 + Number(horario[1]);
                    if (minutos > 1439) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .when("start", {
                  is: (start) => !!start,
                  then: Yup.string().required("Campo vazio!"),
                })
                .when("start", (start, schema) => {
                  return schema.test(
                    "startEqual",
                    "Horários iguais!",
                    (value) => {
                      if (!!start && !!value) {
                        return start !== value;
                      } else {
                        return true;
                      }
                    },
                  );
                }),
            },
            [["start", "end"]],
          ),
        ),
      },
    ),
  });

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        tipoEquipeAcolhimento,
        cargoEquipeAcolhimento,
        regimeTrabalhoAcolhimento,
        regimePlantaoAcolhimento,
        funcaoEquipeAcolhimentoER,
        funcaoEquipeAcolhimentoDPS,
        telefone,
        email,
        inicioAtividade,
        outroRegimePlantao,
        horarioTrabalho,
        listaHorarios,
        domingo,
        segunda,
        terca,
        quarta,
        quinta,
        sexta,
        sabado,
        possuiAcessoMca,
        ...resto
      } = values;
      const tempTipoEA = tipoEquipeAcolhimento
        ? tipoEquipeAcolhimento.nomeEquipe
        : "";
      const tempCargoEquipe = cargoEquipeAcolhimento
        ? cargoEquipeAcolhimento.nomeCargo
        : "";
      const tempRegimeTrabalho = regimeTrabalhoAcolhimento
        ? regimeTrabalhoAcolhimento.nomeRegime
        : "";
      const tempRegimePlantao = regimePlantaoAcolhimento
        ? regimePlantaoAcolhimento.nomeRegime
        : "";

      const horarios = {
        domingo,
        segunda,
        terca,
        quarta,
        quinta,
        sexta,
        sabado,
      };

      const valuesToSend = {
        ...resto,
        idTipoEquipe: tipoEquipeAcolhimento ? tipoEquipeAcolhimento.id : "",
        idFuncaoEquipe:
          tempTipoEA === "Equipe de Referência" ||
          (tipoEquipeAcolhimento.id === 2 &&
            servicoData.tipoServicoAcolhimento.regime === "SAF")
            ? funcaoEquipeAcolhimentoER
              ? funcaoEquipeAcolhimentoER.id
              : ""
            : tempCargoEquipe === "Outros"
              ? funcaoEquipeAcolhimentoDPS
                ? funcaoEquipeAcolhimentoDPS.id
                : ""
              : "",
        idCargoEquipe:
          cargoEquipeAcolhimento &&
          tempTipoEA === "Demais profissionais do Serviço" &&
          servicoData.tipoServicoAcolhimento.regime !== "SAF"
            ? cargoEquipeAcolhimento.id
            : "",
        telefone: tempTipoEA === "Equipe de Referência" ? telefone : "",
        email: tempTipoEA === "Equipe de Referência" ? email : "",
        inicioAtividade: inicioAtividade
          ? parse(inicioAtividade, "dd/MM/yyyy", new Date()).toISOString()
          : "",
        idRegimeTrabalho:
          regimeTrabalhoAcolhimento &&
          tempTipoEA === "Demais profissionais do Serviço"
            ? regimeTrabalhoAcolhimento.id
            : "",
        idRegimePlantao:
          regimePlantaoAcolhimento &&
          tempRegimeTrabalho === "Plantonista" &&
          tempTipoEA === "Demais profissionais do Serviço"
            ? regimePlantaoAcolhimento.id
            : "",
        outroRegimePlantao:
          outroRegimePlantao &&
          tempRegimePlantao === "Outros" &&
          tempTipoEA === "Demais profissionais do Serviço" &&
          tempRegimeTrabalho === "Plantonista"
            ? outroRegimePlantao
            : "",
        horarioTrabalho:
          tempTipoEA === "Equipe de Referência" ||
          tempRegimeTrabalho === "Diarista"
            ? JSON.stringify(horarios)
            : "",
        listaHorarios:
          tempTipoEA === "Equipe de Referência" ||
          tempRegimeTrabalho === "Diarista"
            ? nivelarDias(horarios)
            : [],
        possuiAcessoMca:
          tipoEquipeAcolhimento.nomeEquipe !== "Demais profissionais do Serviço"
            ? possuiAcessoMca.descricao === "Sim"
              ? "S"
              : possuiAcessoMca.descricao === "Não"
                ? "N"
                : ""
            : "",
      };

      EquipeSAService.atualizarMembroSA(id, valuesToSend)
        .then((res) => {
          onClose();
          ((opcaoCadastro === 1 &&
            ["71", "73", "74", "75", "78"].includes(idTipoPendencia)) ||
            (opcaoCadastro === 2 &&
              ["72", "76", "77"].includes(idTipoPendencia))) &&
            history.replace(location.pathname);
          setLoadingPainel && setLoadingPainel(true);
          Swal.fire({
            title: "Sucesso!",
            text: "Registro atualizado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            setEditarEquipeServ(false);
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "membro") {
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message,
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  }).then(() => {});
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(key.toString(), errors[key]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return (
    <Modal isOpen={isOpen} onClose={backAlert} size="6xl">
      <ModalOverlay />
      <ModalContent p="25px" w={{ base: "100%", lg: "70%" }} bgColor="#FFF">
        <ModalHeader
          p="0px"
          fontWeight={700}
          fontSize="14px"
          lineHeight="19.6px"
          color="#95BCBF"
        >
          {isVisualizacao ? "VISUALIZAR EQUIPE" : "EDITAR EQUIPE"}
        </ModalHeader>
        <ModalBody p="0px" mt="25px">
          {!loading ? (
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
              enableReinitialize
            >
              {(props) => (
                <Form>
                  {!isVisualizacao &&
                    setEditarEquipeServ(
                      hasFormChanged(initialValues, props.values),
                    )}
                  <Flex flexDir="column">
                    <Grid
                      templateColumns={{
                        base: "repeat(1, 1fr)",
                        lg: "repeat(2, 1fr)",
                      }}
                      gap="20px"
                      rowGap="15px"
                    >
                      <GridItem colSpan={1}>
                        <Field name="tipoEquipeAcolhimento">
                          {({ field, form }) => (
                            <FormControl
                              isInvalid={
                                form.errors.tipoEquipeAcolhimento &&
                                form.touched.tipoEquipeAcolhimento
                              }
                              id="tipoEquipeAcolhimento"
                            >
                              <FormLabel
                                color="#5F6377"
                                fontWeight="500"
                                fontSize="14px"
                                lineHeight="19.6px"
                                htmlFor="tipoEquipeAcolhimento"
                              >
                                Tipo*
                              </FormLabel>
                              <CustomSelect
                                isInvalid={
                                  form.errors.tipoEquipeAcolhimento &&
                                  form.touched.tipoEquipeAcolhimento
                                }
                                value={props.values.tipoEquipeAcolhimento || ""}
                                searchable={true}
                                getOptionLabel={(option) => option.nomeEquipe}
                                getOptionValue={(option) => option.id}
                                autoload={false}
                                isLoading={tiposEquipe.isLoading}
                                isDisabled={isVisualizacao}
                                options={tiposEquipe.options}
                                placeholder="Selecione o Tipo"
                                onChange={(value) => {
                                  props.setFieldValue(
                                    "tipoEquipeAcolhimento",
                                    value ? value : "",
                                  );
                                }}
                                onFocus={
                                  tiposEquipe.options.length === 0
                                    ? handleGetTiposEquipe
                                    : null
                                }
                              />
                              <FormErrorMessage>
                                {form.errors.tipoEquipeAcolhimento}
                              </FormErrorMessage>
                            </FormControl>
                          )}
                        </Field>
                      </GridItem>

                      {props.values.tipoEquipeAcolhimento !== "" && (
                        <>
                          {props.values.tipoEquipeAcolhimento.nomeEquipe !==
                            "Demais profissionais do Serviço" && (
                            <GridItem colSpan={1}>
                              <Field name="possuiAcessoMca">
                                {({ field, form }) => (
                                  <FormControl
                                    isInvalid={
                                      form.errors.possuiAcessoMca &&
                                      form.touched.possuiAcessoMca
                                    }
                                    id="possuiAcessoMca"
                                  >
                                    <FormLabel
                                      color="#5F6377"
                                      fontWeight="500"
                                      fontSize="14px"
                                      lineHeight="19.6px"
                                      htmlFor="possuiAcessoMca"
                                    >
                                      Acesso ao MCA ?
                                    </FormLabel>
                                    <CustomSelect
                                      isDisabled={
                                        (roleKeycloack &&
                                          !roleKeycloack.includes(
                                            criancaFunc.visualizarTudo,
                                          )) ||
                                        isVisualizacao
                                      }
                                      isInvalid={
                                        form.errors.possuiAcessoMca &&
                                        form.touched.possuiAcessoMca
                                      }
                                      value={props.values.possuiAcessoMca || ""}
                                      searchable={true}
                                      getOptionLabel={(option) =>
                                        option.descricao
                                      }
                                      getOptionValue={(option) => option.id}
                                      autoload={false}
                                      isLoading={acessoMca.isLoading}
                                      options={acessoMca.options}
                                      placeholder="Selecione o Tipo"
                                      onChange={(value) => {
                                        props.setFieldValue(
                                          "possuiAcessoMca",
                                          value ? value : "",
                                        );
                                      }}
                                    />
                                    <FormErrorMessage>
                                      {form.errors.possuiAcessoMca}
                                    </FormErrorMessage>
                                  </FormControl>
                                )}
                              </Field>
                            </GridItem>
                          )}

                          <GridItem colSpan={2}>
                            <Field name="nome">
                              {({ field, form }) => (
                                <FormControl
                                  isInvalid={
                                    form.errors.nome && form.touched.nome
                                  }
                                  id="nome"
                                >
                                  <FormLabel
                                    color="#5F6377"
                                    fontWeight="500"
                                    fontSize="14px"
                                    lineHeight="19.6px"
                                    htmlFor="nome"
                                  >
                                    Nome*
                                  </FormLabel>
                                  <Input
                                    {...field}
                                    isDisabled={isVisualizacao}
                                    h="42px"
                                    name="nome"
                                    id="nome"
                                    backgroundColor="#fff"
                                    autoComplete="off"
                                    border="1px solid #D7D8DE"
                                    placeholder="Informe o Nome"
                                  />
                                  <FormErrorMessage>
                                    {form.errors.nome}
                                  </FormErrorMessage>
                                </FormControl>
                              )}
                            </Field>
                          </GridItem>
                          {(props.values.tipoEquipeAcolhimento !== ""
                            ? props.values.tipoEquipeAcolhimento.nomeEquipe ===
                                "Equipe de Referência" ||
                              (props.values.tipoEquipeAcolhimento.id === 2 &&
                                servicoData.tipoServicoAcolhimento.regime ===
                                  "SAF")
                            : false) && (
                            <>
                              <GridItem colSpan={1}>
                                <Field name="funcaoEquipeAcolhimentoER">
                                  {({ field, form }) => (
                                    <FormControl
                                      name="funcaoEquipeAcolhimentoER"
                                      isInvalid={
                                        form.errors.funcaoEquipeAcolhimentoER &&
                                        form.touched.funcaoEquipeAcolhimentoER
                                      }
                                      id="funcaoEquipeAcolhimentoER"
                                    >
                                      <FormLabel
                                        color="#5F6377"
                                        fontWeight="500"
                                        fontSize="14px"
                                        lineHeight="19.6px"
                                        htmlFor="funcaoEquipeAcolhimentoER"
                                      >
                                        Função*
                                      </FormLabel>
                                      <CustomSelect
                                        isInvalid={
                                          form.errors
                                            .funcaoEquipeAcolhimentoER &&
                                          form.touched.funcaoEquipeAcolhimentoER
                                        }
                                        value={
                                          props.values
                                            .funcaoEquipeAcolhimentoER || ""
                                        }
                                        searchable={true}
                                        getOptionLabel={(option) =>
                                          option.nomeFuncao
                                        }
                                        getOptionValue={(option) => option.id}
                                        autoload={false}
                                        isLoading={funcoesER.isLoading}
                                        isDisabled={isVisualizacao}
                                        options={funcoesER.options}
                                        placeholder="Informe a Função"
                                        onChange={(value) => {
                                          props.setFieldValue(
                                            "funcaoEquipeAcolhimentoER",
                                            value,
                                          );
                                        }}
                                        onFocus={() => {
                                          handleGetFuncoesER(
                                            props.values.tipoEquipeAcolhimento
                                              .id || 0,
                                          );
                                        }}
                                      />
                                      <FormErrorMessage>
                                        {form.errors.funcaoEquipeAcolhimentoER}
                                      </FormErrorMessage>
                                    </FormControl>
                                  )}
                                </Field>
                              </GridItem>
                              <GridItem colSpan={{ base: 2, md: 1 }}>
                                <Field name="telefone">
                                  {({ field, form }) => (
                                    <FormControl
                                      isInvalid={
                                        form.errors.telefone &&
                                        form.touched.telefone
                                      }
                                      id="telefone"
                                    >
                                      <FormLabel
                                        color="#5F6377"
                                        fontWeight="500"
                                        fontSize="14px"
                                        lineHeight="19.6px"
                                        htmlFor="telefone"
                                      >
                                        Telefone
                                      </FormLabel>
                                      <Input
                                        {...field}
                                        isDisabled={isVisualizacao}
                                        maxLength={15}
                                        h="42px"
                                        name={`telefone`}
                                        id={`telefone`}
                                        backgroundColor="#fff"
                                        autoComplete="off"
                                        border="1px solid #D7D8DE"
                                        placeholder="(99) 99999-9999"
                                        onChange={(e) => {
                                          props.setFieldValue(
                                            `telefone`,
                                            telMask(e.target.value),
                                          );
                                        }}
                                      />
                                      <FormErrorMessage>
                                        {form.errors.telefone}
                                      </FormErrorMessage>
                                    </FormControl>
                                  )}
                                </Field>
                              </GridItem>
                              <GridItem colSpan={1}>
                                <Field name="email">
                                  {({ field, form }) => (
                                    <FormControl
                                      isInvalid={
                                        form.errors.email && form.touched.email
                                      }
                                      id="email"
                                    >
                                      <FormLabel
                                        color="#5F6377"
                                        fontWeight="500"
                                        fontSize="14px"
                                        lineHeight="19.6px"
                                        htmlFor="email"
                                      >
                                        E-mail
                                      </FormLabel>
                                      <Input
                                        {...field}
                                        isDisabled={isVisualizacao}
                                        h="42px"
                                        name={`email`}
                                        id={`email`}
                                        backgroundColor="#fff"
                                        autoComplete="off"
                                        border="1px solid #D7D8DE"
                                        placeholder="contato@email.com"
                                        onChange={(e) => {
                                          props.setFieldValue(
                                            `email`,
                                            e.target.value.toLowerCase(),
                                          );
                                        }}
                                      />
                                      <FormErrorMessage>
                                        {form.errors.email}
                                      </FormErrorMessage>
                                    </FormControl>
                                  )}
                                </Field>
                              </GridItem>
                            </>
                          )}
                          {(props.values.tipoEquipeAcolhimento !== ""
                            ? props.values.tipoEquipeAcolhimento.nomeEquipe ===
                                "Demais profissionais do Serviço" &&
                              servicoData.tipoServicoAcolhimento.regime !==
                                "SAF"
                            : false) && (
                            <>
                              <GridItem colSpan={1}>
                                <Field name="cargoEquipeAcolhimento">
                                  {({ field, form }) => (
                                    <FormControl
                                      isInvalid={
                                        form.errors.cargoEquipeAcolhimento &&
                                        form.touched.cargoEquipeAcolhimento
                                      }
                                      id="cargoEquipeAcolhimento"
                                    >
                                      <FormLabel
                                        color="#5F6377"
                                        fontWeight="500"
                                        fontSize="14px"
                                        lineHeight="19.6px"
                                        htmlFor="cargoEquipeAcolhimento"
                                      >
                                        Cargo*
                                      </FormLabel>
                                      <CustomSelect
                                        isInvalid={
                                          form.errors.cargoEquipeAcolhimento &&
                                          form.touched.cargoEquipeAcolhimento
                                        }
                                        value={
                                          props.values.cargoEquipeAcolhimento ||
                                          ""
                                        }
                                        searchable={true}
                                        getOptionLabel={(option) =>
                                          option.nomeCargo
                                        }
                                        getOptionValue={(option) => option.id}
                                        autoload={false}
                                        isLoading={cargos.isLoading}
                                        isDisabled={isVisualizacao}
                                        options={cargos.options}
                                        placeholder="Selecione o Cargo"
                                        onChange={(value) => {
                                          props.setFieldValue(
                                            "cargoEquipeAcolhimento",
                                            value,
                                          );
                                          if (value?.nomeCargo !== "Outros") {
                                            props.setFieldValue(
                                              "funcaoEquipeAcolhimentoDPS",
                                              "",
                                            );
                                          }
                                        }}
                                        onFocus={
                                          cargos.options.length === 0
                                            ? handleGetCargos
                                            : null
                                        }
                                      />
                                      <FormErrorMessage>
                                        {form.errors.cargoEquipeAcolhimento}
                                      </FormErrorMessage>
                                    </FormControl>
                                  )}
                                </Field>
                              </GridItem>
                              {props.values.cargoEquipeAcolhimento &&
                              props.values.cargoEquipeAcolhimento.nomeCargo ===
                                "Outros" ? (
                                <GridItem colSpan={1}>
                                  <Field name="funcaoEquipeAcolhimentoDPS">
                                    {({ field, form }) => (
                                      <FormControl
                                        name="funcaoEquipeAcolhimentoDPS"
                                        isInvalid={
                                          form.errors
                                            .funcaoEquipeAcolhimentoDPS &&
                                          form.touched
                                            .funcaoEquipeAcolhimentoDPS
                                        }
                                        id="funcaoEquipeAcolhimentoDPS"
                                      >
                                        <FormLabel
                                          color="#5F6377"
                                          fontWeight="500"
                                          fontSize="14px"
                                          lineHeight="19.6px"
                                          htmlFor="funcaoEquipeAcolhimentoDPS"
                                        >
                                          Função*
                                        </FormLabel>
                                        <CustomSelect
                                          isInvalid={
                                            form.errors
                                              .funcaoEquipeAcolhimentoDPS &&
                                            form.touched
                                              .funcaoEquipeAcolhimentoDPS
                                          }
                                          value={
                                            props.values
                                              .funcaoEquipeAcolhimentoDPS || ""
                                          }
                                          searchable={true}
                                          getOptionLabel={(option) =>
                                            option.nomeFuncao
                                          }
                                          getOptionValue={(option) => option.id}
                                          autoload={false}
                                          isLoading={funcoesDPS.isLoading}
                                          isClearable={true}
                                          isDisabled={
                                            isVisualizacao ||
                                            (props.values.cargoEquipeAcolhimento
                                              ? props.values
                                                  .cargoEquipeAcolhimento
                                                  .nomeCargo !== "Outros"
                                              : true)
                                          }
                                          options={funcoesDPS.options}
                                          placeholder="Informe a Função"
                                          onChange={(value) => {
                                            props.setFieldValue(
                                              "funcaoEquipeAcolhimentoDPS",
                                              value,
                                            );
                                          }}
                                          onFocus={() => {
                                            handleGetFuncoesDPS(
                                              props.values.tipoEquipeAcolhimento
                                                .id || 0,
                                            );
                                          }}
                                        />
                                        <FormErrorMessage>
                                          {
                                            form.errors
                                              .funcaoEquipeAcolhimentoDPS
                                          }
                                        </FormErrorMessage>
                                      </FormControl>
                                    )}
                                  </Field>
                                </GridItem>
                              ) : (
                                <GridItem colSpan={1} />
                              )}
                            </>
                          )}
                          <GridItem colSpan={{ base: 2, md: 1 }}>
                            <CustomDatepickerWField
                              fieldName="inicioAtividade"
                              label="Início das Atividades no Serviço de Acolhimento*"
                              placeholder="DD/MM/AAAA"
                              isDisabled={isVisualizacao}
                            />
                          </GridItem>
                          {props.values.tipoEquipeAcolhimento.id === 2 &&
                            servicoData.tipoServicoAcolhimento.regime !==
                              "SAF" && <GridItem colSpan={1} />}
                          <GridItem colSpan={1}>
                            <Field name="cargaHorariaSemanal">
                              {({ field, form }) => (
                                <FormControl
                                  isInvalid={
                                    form.errors.cargaHorariaSemanal &&
                                    form.touched.cargaHorariaSemanal
                                  }
                                  id="cargaHorariaSemanal"
                                >
                                  <FormLabel
                                    color="#5F6377"
                                    fontWeight="500"
                                    fontSize="14px"
                                    lineHeight="19.6px"
                                    htmlFor="cargaHorariaSemanal"
                                  >
                                    Carga Horária Semanal (Digite Apenas os
                                    Números)*
                                  </FormLabel>
                                  <Input
                                    {...field}
                                    isDisabled={isVisualizacao}
                                    h="42px"
                                    name={`cargaHorariaSemanal`}
                                    id={`cargaHorariaSemanal`}
                                    backgroundColor="#fff"
                                    autoComplete="off"
                                    border="1px solid #D7D8DE"
                                    placeholder="Informe"
                                    maxLength={3}
                                    onChange={(e) => {
                                      form.setFieldValue(
                                        "cargaHorariaSemanal",
                                        numbersMask(e.target.value),
                                      );
                                    }}
                                  />
                                  <FormErrorMessage>
                                    {form.errors.cargaHorariaSemanal}
                                  </FormErrorMessage>
                                </FormControl>
                              )}
                            </Field>
                          </GridItem>

                          {(props.values.tipoEquipeAcolhimento !== ""
                            ? props.values.tipoEquipeAcolhimento.nomeEquipe ===
                              "Demais profissionais do Serviço"
                            : false) && (
                            <>
                              <GridItem colSpan={1}>
                                <Field name="regimeTrabalhoAcolhimento">
                                  {({ field, form }) => (
                                    <FormControl
                                      name="regimeTrabalhoAcolhimento"
                                      isInvalid={
                                        form.errors.regimeTrabalhoAcolhimento &&
                                        form.touched.regimeTrabalhoAcolhimento
                                      }
                                      id="regimeTrabalhoAcolhimento"
                                    >
                                      <FormLabel
                                        color="#5F6377"
                                        fontWeight="500"
                                        fontSize="14px"
                                        lineHeight="19.6px"
                                        htmlFor="regimeTrabalhoAcolhimento"
                                      >
                                        Regime de Trabalho*
                                      </FormLabel>
                                      <CustomSelect
                                        isInvalid={
                                          form.errors
                                            .regimeTrabalhoAcolhimento &&
                                          form.touched.regimeTrabalhoAcolhimento
                                        }
                                        value={
                                          props.values
                                            .regimeTrabalhoAcolhimento || ""
                                        }
                                        searchable={true}
                                        getOptionLabel={(option) =>
                                          option.nomeRegime
                                        }
                                        getOptionValue={(option) => option.id}
                                        autoload={false}
                                        isLoading={regimesTrabalho.isLoading}
                                        isDisabled={isVisualizacao}
                                        options={regimesTrabalho.options}
                                        placeholder="Selecione o Regime"
                                        onChange={(value) => {
                                          props.setFieldValue(
                                            "regimeTrabalhoAcolhimento",
                                            value,
                                          );
                                        }}
                                        onFocus={
                                          regimesTrabalho.options.length === 0
                                            ? handleGetRegimesTrabalho
                                            : null
                                        }
                                      />
                                      <FormErrorMessage>
                                        {form.errors.regimeTrabalhoAcolhimento}
                                      </FormErrorMessage>
                                    </FormControl>
                                  )}
                                </Field>
                              </GridItem>
                              {(props.values.regimeTrabalhoAcolhimento
                                ? props.values.regimeTrabalhoAcolhimento
                                    .nomeRegime === "Plantonista"
                                : false) && (
                                <>
                                  <GridItem colSpan={1}>
                                    <Field name="regimePlantaoAcolhimento">
                                      {({ field, form }) => (
                                        <FormControl
                                          name="regimePlantaoAcolhimento"
                                          isInvalid={
                                            form.errors
                                              .regimePlantaoAcolhimento &&
                                            form.touched
                                              .regimePlantaoAcolhimento
                                          }
                                          id="regimePlantaoAcolhimento"
                                        >
                                          <FormLabel
                                            color="#5F6377"
                                            fontWeight="500"
                                            fontSize="14px"
                                            lineHeight="19.6px"
                                            htmlFor="regimePlantaoAcolhimento"
                                          >
                                            Regime de Plantão*
                                          </FormLabel>
                                          <CustomSelect
                                            isInvalid={
                                              form.errors
                                                .regimePlantaoAcolhimento &&
                                              form.touched
                                                .regimePlantaoAcolhimento
                                            }
                                            value={
                                              props.values
                                                .regimePlantaoAcolhimento || ""
                                            }
                                            searchable={true}
                                            getOptionLabel={(option) =>
                                              option.nomeRegime
                                            }
                                            getOptionValue={(option) =>
                                              option.id
                                            }
                                            autoload={false}
                                            isLoading={regimesPlantao.isLoading}
                                            isDisabled={isVisualizacao}
                                            options={regimesPlantao.options}
                                            placeholder="Selecione"
                                            onChange={(value) => {
                                              props.setFieldValue(
                                                "regimePlantaoAcolhimento",
                                                value,
                                              );
                                            }}
                                            onFocus={
                                              regimesPlantao.options.length ===
                                              0
                                                ? handleGetRegimesPlantao
                                                : null
                                            }
                                          />
                                          <FormErrorMessage>
                                            {
                                              form.errors
                                                .regimePlantaoAcolhimento
                                            }
                                          </FormErrorMessage>
                                        </FormControl>
                                      )}
                                    </Field>
                                  </GridItem>
                                  {(props.values.regimePlantaoAcolhimento
                                    ? props.values.regimePlantaoAcolhimento
                                        .nomeRegime === "Outros"
                                    : false) && (
                                    <GridItem colSpan={1}>
                                      <Field name="outroRegimePlantao">
                                        {({ field, form }) => (
                                          <FormControl
                                            isInvalid={
                                              form.errors.outroRegimePlantao &&
                                              form.touched.outroRegimePlantao
                                            }
                                            id="outroRegimePlantao"
                                          >
                                            <FormLabel
                                              color="#5F6377"
                                              fontWeight="500"
                                              fontSize="14px"
                                              lineHeight="19.6px"
                                              htmlFor="outroRegimePlantao"
                                            >
                                              Informe o Regime de Plantão*
                                            </FormLabel>
                                            <Input
                                              {...field}
                                              isDisabled={isVisualizacao}
                                              h="42px"
                                              name="outroRegimePlantao"
                                              id="outroRegimePlantao"
                                              backgroundColor="#fff"
                                              autoComplete="off"
                                              border="1px solid #D7D8DE"
                                              placeholder="Informe"
                                            />
                                            <FormErrorMessage>
                                              {form.errors.outroRegimePlantao}
                                            </FormErrorMessage>
                                          </FormControl>
                                        )}
                                      </Field>
                                    </GridItem>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </Grid>
                    {((props.values.tipoEquipeAcolhimento !== ""
                      ? props.values.tipoEquipeAcolhimento.nomeEquipe ===
                        "Equipe de Referência"
                      : false) ||
                      (props.values.regimeTrabalhoAcolhimento
                        ? props.values.regimeTrabalhoAcolhimento.nomeRegime ===
                          "Diarista"
                        : false)) && (
                      <Flex
                        flexDir="column"
                        mt={6}
                        border="1px solid #D7D8DE"
                        borderRadius="base"
                        pl="2"
                      >
                        <Text
                          color="#5F6377"
                          fontWeight="500"
                          fontSize="14px"
                          lineHeight="19.6px"
                          mt="12px"
                        >
                          Horário de Trabalho*
                        </Text>
                        <Text
                          color="#e53e3e"
                          fontSize="14px"
                          mt={props.errors.listaHorarios ? "5px" : "0px"}
                        >
                          {props.errors.listaHorarios
                            ? props.errors.listaHorarios
                            : ""}
                        </Text>
                        <DiaHorario
                          fieldName="domingo"
                          title="Domingo:"
                          mt="10px"
                          formProps={props}
                          isVisualizacao={isVisualizacao}
                        />
                        <DiaHorario
                          fieldName="segunda"
                          title="Segunda-feira:"
                          formProps={props}
                          isVisualizacao={isVisualizacao}
                        />
                        <DiaHorario
                          fieldName="terca"
                          title="Terça-feira:"
                          formProps={props}
                          isVisualizacao={isVisualizacao}
                        />
                        <DiaHorario
                          fieldName="quarta"
                          title="Quarta-feira:"
                          formProps={props}
                          isVisualizacao={isVisualizacao}
                        />
                        <DiaHorario
                          fieldName="quinta"
                          title="Quinta-feira:"
                          formProps={props}
                          isVisualizacao={isVisualizacao}
                        />
                        <DiaHorario
                          fieldName="sexta"
                          title="Sexta-feira:"
                          formProps={props}
                          isVisualizacao={isVisualizacao}
                        />
                        <DiaHorario
                          fieldName="sabado"
                          title="Sábado:"
                          formProps={props}
                          isVisualizacao={isVisualizacao}
                        />
                      </Flex>
                    )}

                    <SimpleGrid
                      alignSelf="center"
                      mt="20px"
                      columns={{ base: 1, lg: isVisualizacao ? 3 : 2 }}
                      spacing="15px"
                      w={{ base: "100%", lg: isVisualizacao ? "50%" : "40%" }}
                    >
                      <Button
                        id="button-voltar-modal"
                        color="#FFF"
                        backgroundColor="#169499"
                        fontWeight={700}
                        fontSize="15px"
                        lineHeight="21.6px"
                        _hover={{ bg: "#169499" }}
                        onClick={backAlert}
                      >
                        Voltar
                      </Button>
                      {!isVisualizacao && (
                        <Button
                          id="button-salvar-modal"
                          type="submit"
                          translate="no"
                          color="#FFF"
                          backgroundColor="#169499"
                          fontWeight={700}
                          fontSize="15px"
                          lineHeight="21.6px"
                          _hover={{ bg: "#169499" }}
                          isLoading={props.isSubmitting}
                        >
                          Salvar
                        </Button>
                      )}
                      {isVisualizacao && (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={servicos.equipeEditar}
                          id={idPJ}
                          user={user}
                        >
                          <Button
                            id="button-editar-modal"
                            color="#FFF"
                            backgroundColor="#169499"
                            fontWeight={700}
                            fontSize="15px"
                            lineHeight="21.6px"
                            _hover={{ bg: "#169499" }}
                            onClick={() => {
                              setIsVisualizacao(false);
                            }}
                          >
                            Editar
                          </Button>
                        </Permission>
                      )}
                      {isVisualizacao && (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={servicos.equipeDesligar}
                          id={idPJ}
                          user={user}
                        >
                          <Button
                            id="button-desligar-modal"
                            color="#FFF"
                            backgroundColor="#169499"
                            fontWeight={700}
                            fontSize="15px"
                            lineHeight="21.6px"
                            _hover={{ bg: "#169499" }}
                            onClick={onOpenDesligar}
                          >
                            Desligar
                          </Button>
                        </Permission>
                      )}
                    </SimpleGrid>
                  </Flex>
                </Form>
              )}
            </Formik>
          ) : (
            <Flex w="100%" mt="25%" justifyContent="center">
              <LoadingSpinner />
            </Flex>
          )}
          {isOpenDesligar && (
            <DesligarModal
              isOpen={isOpenDesligar}
              onOpen={onOpenDesligar}
              onClose={onCloseDesligar}
              id={id}
              inicioAtividade={initialValues.inicioAtividade}
              handleMembroDesligado={handleMembroDesligado}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default VisualizarEditarEquipeModal;
